import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { SurveyQuestion } from '../models/survey-question.model';
//import { SurveyQuestionVm } from 'src/shared/service-proxies/service-proxies';
//import { StateService } from '../services/state.service';
import { PeopleDto } from "../models/people.model";
import { DataService } from '../services/GlobalService/data.service';

@Component({
    selector:'job-desc-sparky',
  styleUrls: ["./ui-styles.css"],
  template: `<mat-form-field *ngIf="
      currentQuestion?.dataTypeName == 'jobDescSPARK'">
    <input matInput [value]="currentQuestion.answerText" [disabled] = "true" />
  </mat-form-field>`
})

export class JobDescSPARKYComponent implements OnInit {
  textInput = new UntypedFormControl("");
  private _currentQuestion: SurveyQuestion;
  @Input() set currentQuestion(value){
   this._currentQuestion = value;
  };
  emp: string | null = null;
  ngOnChanges() {
    if (this.emp) {
      this.currentQuestion.answerText = this.emp;
      console.log("Check: ", this.currentQuestion.answerText);
    }
  }
  constructor(private dataService: DataService) { }
  get currentQuestion(){
   return this._currentQuestion;
  };
  ngOnInit() {
    this.dataService.selectedPerson$.subscribe(person => {
      if (person) {
        this.emp = person;
        if (this.currentQuestion.dataTypeName == 'jobDescSPARK') {
          this.currentQuestion.answerText = this.emp;
        }
      }
    });
  }
}
